import { cn } from '@lib/utils';
import type { FC, ReactNode } from 'react';

type MeiaInnerSectionProps = {
  /** Optional control rendered at the top-right of the section header. */
  action?: ReactNode;
  children: ReactNode;
  className?: string;
  description?: ReactNode;
  title: ReactNode;
};

/**
 * Bordered inner section used to group related fields inside a larger tile/form
 * (e.g. the Mission Framing editor). Renders a prominent subtitle heading — not a
 * BlueLabel — plus an optional description and a top-right action slot. The root is
 * a `group` so action buttons can reveal on hover.
 */
export const MeiaInnerSection: FC<MeiaInnerSectionProps> = (props) => {
  const { action, children, className, description, title } = props;

  return (
    <section className={cn('group flex flex-col gap-3 rounded-md border border-gray-200 p-3', className)}>
      <div className="flex items-start justify-between gap-2">
        <div className="flex min-w-0 flex-col gap-0.5">
          <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
          {description && <p className="text-xs text-gray-500">{description}</p>}
        </div>
        {action}
      </div>
      {children}
    </section>
  );
};
